import { type ComponentPropsWithRef, forwardRef } from 'react';

import { cn } from '@/lib/cn';

export const SettingSection = forwardRef<
  HTMLDivElement,
  ComponentPropsWithRef<'div'>
>((props, ref) => {
  const { children, className, ...rest } = props;
  return (
    <div
      className={cn('flex flex-col border-b py-8 gap-4 flex-start', className)}
      {...rest}
      ref={ref}
    >
      {children}
    </div>
  );
});
